import { useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import type { ContactFormValues } from "../types";

export interface ContactFormProps {
  id: string;
  initialValues: ContactFormValues;
  isSubmitting: boolean;
  onSubmit: (values: ContactFormValues) => void;
}

export const ContactForm = ({
  id,
  initialValues,
  isSubmitting,
  onSubmit,
}: ContactFormProps): JSX.Element => {
  const [values, setValues] = useState<ContactFormValues>(initialValues);

  const set = <K extends keyof ContactFormValues>(
    key: K,
    v: ContactFormValues[K]
  ) => setValues((prev) => ({ ...prev, [key]: v }));

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (isSubmitting) return;
    onSubmit(values);
  };

  return (
    <Form id={id} data-testid={id} onSubmit={handleSubmit}>
      <Row>
        <Col sm={6}>
          <Form.Group className="mb-3">
            <Form.Label htmlFor="contact-name">Name</Form.Label>
            <Form.Control
              id="contact-name"
              type="text"
              required
              placeholder="Jane Smith"
              value={values.name}
              onChange={(e) => set("name", e.target.value)}
            />
          </Form.Group>
        </Col>
        <Col sm={6}>
          <Form.Group className="mb-3">
            <Form.Label htmlFor="contact-title">Title</Form.Label>
            <Form.Control
              id="contact-title"
              type="text"
              placeholder="CEO"
              value={values.title}
              onChange={(e) => set("title", e.target.value)}
            />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <Form.Group className="mb-3">
            <Form.Label htmlFor="contact-email">Email</Form.Label>
            <Form.Control
              id="contact-email"
              type="email"
              placeholder="jane.smith@customer.com"
              value={values.email}
              onChange={(e) => set("email", e.target.value)}
            />
          </Form.Group>
        </Col>
        <Col sm={6}>
          <Form.Group className="mb-3">
            <Form.Label htmlFor="contact-phone">Phone</Form.Label>
            <Form.Control
              id="contact-phone"
              type="text"
              placeholder="212-555-1234"
              value={values.phone}
              onChange={(e) => set("phone", e.target.value)}
            />
          </Form.Group>
        </Col>
      </Row>
    </Form>
  );
};

export default ContactForm;
